export const isTrialUsed = ({ subscription }: { subscription: any }) =>
    subscription.free_trial_state === 'used';

export const isCanceled = ({ subscription }: { subscription: any }) =>
    subscription && subscription.renewable && subscription.renewable.canceled;
